import React, { Component } from "react";
import { Box } from "reflexbox";
import { Panel, PanelType } from "office-ui-fabric-react/lib/Panel";

import { withRouter } from "react-router-dom";
import { Nav } from "office-ui-fabric-react/lib/Nav";
import { Icon } from "office-ui-fabric-react/lib/Icon";
import ArchiveSwitch from "../../common/Buttons/_ArchiveSwitch";

class MenuPanel extends Component {
  constructor() {
    super();
    this.state = {
      isModalVisible: false
    };
  }

  toggleModal = () => {
    this.setState({ isModalVisible: !this.state.isModalVisible });
  };

  dismissModal = () => {
    this.setState({ isModalVisible: false });
  };

  _onClickHandler = e => {
    e.preventDefault();
    this.props.history.push(e.currentTarget.pathname);
    this.dismissModal();
  };

  _onRenderLink = link => {
    if (link.orders > 0) {
      return (
        <Box flex>
          <Box>{link.name} </Box>
          <Box pl={1} style={{ color: "red" }}>{`${
            link.orders
          } new orders`}</Box>
        </Box>
      );
    } else return <div>{link.name}</div>;
  };

  render() {
    return (
      <div
        style={{
          height: "50px",
          width: "50px",
          borderWidth: "1px",
          borderRightStyle: "solid",
          borderColor: "#C6E0FF",
          cursor: "pointer"
        }}
        onClick={this.toggleModal}
        title="Menu"
      >
        <Icon
          iconName={"Waffle"}
          style={{
            fontSize: 30,
            color: "#C6E0FF",
            marginTop: "10px",
            marginLeft: "10px"
          }}
        />
        <Panel
          className="menu-panel"
          isBlocking={true}
          isOpen={this.state.isModalVisible}
          onDismiss={this.dismissModal}
          isLightDismiss={true}
          type={PanelType.smallFixedNear}
          forceFocusInsideTram={true}
        >
          <Nav
            onRenderLink={link => this._onRenderLink(link)}
            groups={[
              {
                links: [
                  {
                    name: "Planning",
                    key: "Planning",
                    url: "/planning",
                    onClick: this._onClickHandler
                  },
                  {
                    name: "Shipments",
                    key: "Shipments",
                    url: "/shipments",
                    onClick: this._onClickHandler
                  },
                  {
                    name: "Orders",
                    orders: this.props.data ? this.props.data.countOrders : "",
                    key: "Orders",
                    url: "/orders",
                    onClick: this._onClickHandler
                  },
                  {
                    name: "Relations",
                    key: "Relations",
                    url: "/relations",
                    onClick: this._onClickHandler
                  },
                  {
                    name: "Carriers",
                    key: "Carriers",
                    url: "/carriers",
                    onClick: this._onClickHandler
                  }
                ]
              }
            ]}
          />
          <ArchiveSwitch />
        </Panel>
      </div>
    );
  }
}

export default withRouter(MenuPanel);



// WEBPACK FOOTER //
// ./src/views/App/_MenuPanel.js